/**
 * Keep the centred desktop nav clear of the logo and the AUD / icon cluster
 * (ClickUp 14yp17zv5h0, BugHerd 31480426 - "the pricing option is covering the
 * reviews in the NAV").
 *
 * On the v5 header the link row is centred on the PAGE (custom.css, "Centre
 * the nav on the page"), so it does not know where the flanks are. The right
 * flank is ~85px wider than the logo, so the row runs out of room on that side
 * first: at 1200px there is only ~7px between REVIEWS and AUD with the web
 * font, and anything wider - a longer currency label, a fallback or platform
 * font, a slightly different laptop width - makes them overlap.
 *
 * This measures the real clearance and, only when the right side is short:
 *   1. slides the row left (via --nav-shift, read by custom.css) using the
 *      spare room on the logo side, never past an even split;
 *   2. if both sides are still short, tightens the link gap
 *      (.wt-header__body--nav-tight) and measures again.
 * When there is room the row stays exactly page-centred, as designed.
 *
 * Padding (not a transform) does the shift: the nav box is the containing
 * block for the mega dropdown, and a transform on the list would become a new
 * one and shrink the panel.
 */
(function () {
  var MIN_CLEARANCE = 24; // px wanted between the row and each flank
  var DESKTOP = 1200; // the theme's nav/hamburger switch (custom.css)

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function measure(body, list) {
    var items = Array.prototype.filter.call(
      list.querySelectorAll(':scope > .wt-page-nav-mega__item'),
      visible
    );
    var logo = body.querySelector('.wt-header__logo-wrapper');
    var flank = [
      body.querySelector(':scope > .wt-header__localization__triggers'),
      body.querySelector(':scope > .wt-header__aside')
    ].filter(visible);
    if (!items.length || !visible(logo) || !flank.length) return null;

    var rowLeft = items[0].getBoundingClientRect().left;
    var rowRight = items[items.length - 1].getBoundingClientRect().right;
    var flankLeft = Math.min.apply(
      null,
      flank.map(function (el) {
        return el.getBoundingClientRect().left;
      })
    );
    return {
      left: rowLeft - logo.getBoundingClientRect().right,
      right: flankLeft - rowRight
    };
  }

  function fit(body) {
    var list = body.querySelector(
      '.wt-header__nav-teaser--full-menu .wt-page-nav-mega__list'
    );
    if (!list) return;

    // Reset to the designed layout before measuring.
    body.style.removeProperty('--nav-shift');
    body.classList.remove('wt-header__body--nav-tight');

    if (window.innerWidth < DESKTOP || document.body.classList.contains('mobile-nav')) {
      return;
    }

    var clear = measure(body, list);
    if (!clear) return;

    if (clear.left + clear.right < MIN_CLEARANCE * 2) {
      body.classList.add('wt-header__body--nav-tight');
      clear = measure(body, list);
      if (!clear) return;
    }

    if (clear.right < MIN_CLEARANCE) {
      var shift = Math.min(
        MIN_CLEARANCE - clear.right,
        Math.max(0, (clear.left - clear.right) / 2)
      );
      if (shift > 0) body.style.setProperty('--nav-shift', Math.ceil(shift) + 'px');
    }
  }

  function boot() {
    var body = document.querySelector('.wt-header--v5 .wt-header__body');
    if (!body) return;

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        fit(body);
      });
    }

    schedule();
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

    // The currency label can change width (country switch, late hydration).
    if ('ResizeObserver' in window) {
      var triggers = body.querySelector(':scope > .wt-header__localization__triggers');
      var logo = body.querySelector('.wt-header__logo-wrapper');
      var ro = new ResizeObserver(schedule);
      [triggers, logo].forEach(function (el) {
        if (el) ro.observe(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
